
import Vue from 'vue';
import PublicAthleteSideNav from '../components/navigation/PublicAthleteSideNav.vue';
import PublicAppBar from '../components/navigation/PublicAppBar.vue';
import Footer from '../components/navigation/Footer.vue';
import { userStore } from '@/store';

export default Vue.extend({
	components: { PublicAppBar, PublicAthleteSideNav, Footer },
	data(){
		return {
			showSideNav: true,
		};
	},
	created(){
		if(this.CollapseSideNav) this.showSideNav = false;
	},
	computed: {
		CollapseSideNav(){
			return this.$vuetify.breakpoint.mobile;
		},
		ShowSystemBar(): boolean{
			return this.$slots['system-bar'] !== undefined;
		},
		UseFullscreen(): boolean{
			return this.$route.meta?.useFullscreen ===  true;
		},
		IsLoggedIn(): boolean {
            return userStore.IsLoggedIn;
        }
	}
});
